const samePageAnchorSelector = 'a[href^="#"], a[href*="/#"]';
function getFixedHeaderOffset() {
  return document.documentElement.classList.contains('--tablet')
    || document.documentElement.classList.contains('--mobile')
    ? 120
    : 0;
}

function getAnchorTarget(link) {
  const url = new URL(link.href, window.location.href);

  if (
    url.origin !== window.location.origin
    || url.pathname !== window.location.pathname
    || url.search !== window.location.search
    || !url.hash
    || url.hash === '#'
  ) {
    return null;
  }

  const id = decodeURIComponent(url.hash.slice(1));
  return document.getElementById(id) || document.getElementsByName(id)[0] || null;
}

export function initSmoothScroll() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', (event) => {
    const link = event.target.closest(samePageAnchorSelector);

    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const target = getAnchorTarget(link);

    if (!target) {
      return;
    }

    event.preventDefault();

    window.scrollTo({
      top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - getFixedHeaderOffset()),
      behavior: reduceMotion.matches ? 'auto' : 'smooth',
    });

    window.history.pushState(null, '', link.hash);
  });
}
